<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DEPARTMENT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Department Details
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getDetail()">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <v-flex xs12 class="pa-7">
          <v-layout row wrap>
            <table width="80%">
              <tr>
                <td width="20%">Department Name</td>
                <td width="3%">:</td>
                <td width="60%" class="grey--text">
                  {{ department.name ? department.name : '-' }}
                </td>
              </tr>
              <tr>
                <td>Division</td>
                <td>:</td>
                <td class="grey--text">
                  {{ department.division ? department.division.name : '-' }}
                </td>
              </tr>
              <tr>
                <td>Head</td>
                <td>:</td>
                <td class="grey--text">
                  {{ department.head ? department.head : '-' }}
                </td>
              </tr>
              <tr>
                <td>Head Email</td>
                <td>:</td>
                <td class="grey--text">
                  {{ department.head_email ? department.head_email : '-' }}
                </td>
              </tr>
              <tr>
                <td>House</td>
                <td>:</td>
                <td class="grey--text">
                  <span v-if="department.connection.length === 0">
                    -
                  </span>
                  <ul
                    v-else
                    v-for="house in department.connection"
                    :key="house.id"
                    class="px-0"
                  >
                    {{
                      house.house.name
                    }}
                  </ul>
                </td>
              </tr>
              <tr>
                <td>Description</td>
                <td>:</td>
                <td class="grey--text">
                  {{ department.desc || '-' }}
                </td>
              </tr>
            </table>
          </v-layout>
        </v-flex>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 right class="mr-8 my-5">
            <v-btn
              id="btn-cancel"
              dark
              rounded
              color="red"
              block
              :to="{ name: 'department' }"
            >
              Back
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: ['id'],
  components: { 'progress-dialog': ProgressDialog },
  data() {
    return {
      name: '',
      loading: true,
      progressDialogLoading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Department List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Department Detail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      department: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('department/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.department = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>
<style>
tr:hover {
  background: none !important;
}
</style>
